import APIHost from '../APIHost';
import { DiscountSourceType } from '../Enums/PromoMatrix/DiscountSourceType';
import AppliedOrderLineDiscount from '../Interfaces/PromoMatrix/AppliedOrderLineDiscount';
import { ProductDetailsOption } from '../Redux/Reducers/App_Reducers/ProductDetailsReducer';

const apiHost = new APIHost();

export const GetProductImageUrl = (imagePath:string) => {
    let appSettings = apiHost.GetEnvironmentConfig();
    
    if (appSettings && imagePath && imagePath.length > 0) {

        if (imagePath.includes('https://')) {
            return imagePath;
        }

        return appSettings.WebFilesHost + imagePath;
    }

    return '';
};

// Check if a list of product options contains sizes.
export const ContainsSizes = (list: any[]) => {
    let containsSizes = list.some((options: any[]) =>
        {
            return options.some((item: any) => item.size || (item.uomSize && options.length > 1))
        }
    );
    return containsSizes;
};

// Check if a list of product options contains UOMs.
export const ContainsUoms = (list: any[]) => {
    return list.find((item: any) => item.uomId) !== undefined;
};

// Group a list by the given keys.
export const GroupByKey = (array: any[], f: any) => {
    let groups: any = {};
    array.forEach(function (o) {
        var group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
    });
    return Object.keys(groups).map(function (group) {
        return groups[group];
    })
};

export const RoundStockNumber = (stockNumber: number) => {
    return Math.floor(stockNumber);
};


export function getContractPrice(promotions: AppliedOrderLineDiscount[]): number {
    const contractPrices = promotions
      .map((promotion) => promotion.contractPrice)
      .filter((price): price is number => price !== null);
  
      return contractPrices.length === 1 ? contractPrices[0] : 0;
    }
export const GetTotalProductOptionPrice = (option: ProductDetailsOption) => {
    if(option.contractPrice){
        if(option.uomSize){
            return option.contractPrice * option.uomSize * option.productQuantity;
        }
        return option.contractPrice * option.productQuantity;
    }

    if(option.lineItemDiscount){
        let price = option.discountSource === DiscountSourceType.PriceTier && option.retailPrice > 0 
            ? option.retailPrice
            : option.price;
        if(option.discountSource === DiscountSourceType.SpecialPrice && option.uomSize && option.baseUnitPrice){
            price = option.baseUnitPrice * option.uomSize;
        }
        
        return (price * option.productQuantity) - option.lineItemDiscount;
    }
    const isValidUnitDiscount = IsThereAValidUnitDiscountBetweenPriceAndSpecialPrice(option);
    if (isValidUnitDiscount) {
        return option.specialPrice * option.productQuantity;
    } else {
        return option.price * option.productQuantity;
    }
}

export const IsThereAValidUnitDiscountBetweenPriceAndSpecialPrice = (option: ProductDetailsOption) : boolean=> {
    const {specialPrice, price} = option;
    return !option.contractPrice && !!specialPrice && specialPrice < price;
}

export const GetLineItemDiscount = (option : ProductDetailsOption) => {
    const { price, specialPrice, productQuantity } = option;
    return option.lineItemDiscount > 0 ? option.lineItemDiscount : 
        IsThereAValidUnitDiscountBetweenPriceAndSpecialPrice(option) ? Math.abs(price - specialPrice) * productQuantity : 0;
}

export const GetSpecialPriceDiscount = (option : ProductDetailsOption) => {
    const {price, specialPrice, productQuantity} = option;
    return option.hasOwnProperty("price") && !Number.isNaN(price) && price > 0 && !Number.isNaN(productQuantity) && productQuantity > 0 &&
        IsThereAValidUnitDiscountBetweenPriceAndSpecialPrice(option) ? Math.abs(price - specialPrice) * productQuantity : 0;
}

export const ProductObjectContainsOptionId = (product: any) => {
    return product && product.hasOwnProperty("optionId") && product.optionId;
}

export const FormatIncomingDate = (value: string | null) => {

    if (value) {
        const date = new Date( Date.parse(value) );

        const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
    
        return `${da} ${mo}`;
    }

    return "";
};
